import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormArray } from '@angular/forms';
import { SectorService } from './../services/sector.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { LegModel } from './../models/leg-model';
import { CommonServiceService } from 'src/app/shared/common-service.service';


@Component({
	selector: 'app-sector-info',
	templateUrl: './sector-info.component.html',
	styleUrls: ['../flight.component.scss']
})
export class SectorInfoComponent implements OnInit {
	dateTimeMultiTab: string = "false";

	bsConfig: Partial<BsDatepickerConfig>;
	colorTheme = 'theme-orange';
	leg : LegModel = new LegModel();
	@Input() sectorService;
	@Input() isTenantIndian;
	dateFormat = 'YYYY-MM-DD';
	dateTimeFormat = 'YYYY-MM-DD HH:mm';
	timeFormat = 'HH:mm';
  	isLocaleDateFormat: boolean = true;
	constructor(
		public commonService : CommonServiceService
	) { }

	async ngOnInit() {
		this.bsConfig = Object.assign({ dateInputFormat: 'DD/MM/YYYY HH:mm' }, { containerClass: this.colorTheme }, { showWeekNumbers: false })	
		let globalSettingConfig = this.commonService.globalSettingConfig;
		if(!globalSettingConfig || globalSettingConfig.length == 0) {
			globalSettingConfig = await this.commonService.getGlobalSettings();
		}
			let inv_config = globalSettingConfig.filter(el=>el.group=='FLIGHT_INV')
			if(inv_config.length){
				let multi_tav_config = inv_config[0].json_doc.value.filter(el=>el.key=='MULTI TAB TRAVEL DATE TIME')
				if(multi_tav_config && multi_tav_config.length>0) this.dateTimeMultiTab = multi_tav_config[0].value
			}
		let transaction_config = globalSettingConfig.filter(el=>el.group=='TRANSACTION')
		if(transaction_config && transaction_config.length>0){      
			let dateConfig = await this.commonService.getDateFormat('date_format')
			this.dateFormat = dateConfig.dateFormat
			let dateTimeConfig = await this.commonService.getDateFormat('date_time_format')
			this.dateTimeFormat = dateTimeConfig.dateFormat
			this.isLocaleDateFormat = dateConfig.isLocaleDateFormat
		}
		console.log("this.dateTimeMultiTab ",this.dateTimeMultiTab)
	}

	removeSector(i,sectorList) {
		 
		this.sectorService[sectorList].removeAt(i)
		this.sectorService.removeSectorFromTravellers(i)
	}

	checkl(data){
		console.log(data)
	}
}
